import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaTimes } from "react-icons/fa";
import React from "react";

const MySwal = withReactContent(Swal);

export const logoutWithWarning = (logoutFunction) => {
  const hasUnsavedTeamScores = sessionStorage.getItem("hasUnsavedTeamScores");
  const hasUnsavedCarePlan = sessionStorage.getItem("hasUnsavedCarePlan");
  const hasUnsavedFunctionalReview = sessionStorage.getItem("hasUnsavedFunctionalReview");

  if (hasUnsavedTeamScores === "true" || hasUnsavedCarePlan === "true" || hasUnsavedFunctionalReview === "true") {
    // Show warning modal
    MySwal.fire({
      width: "395px",
      html: (
        <div>
          <div className="d-flex justify-content-end">
            <FaTimes
              color="#50a193"
              size={15}
              fontWeight={"bolder"}
              className="cursor-pointer"
              onClick={() => MySwal.close()}
            />
          </div>
          <h4 className="text_primary font-weight-bold fs-18 mb-35">
            Warning
          </h4>
          <p className="fs-15 mb-1">Are you sure you want to logout?</p>
          <p className="fs-15 mb-43">
            <span className="font-weight-bold">Note:</span> All unsaved data
            will be lost
          </p>
          <div className="d-flex justify-content-between">
            <button
              className="btn btn_outline_danger overlay-btn small-text"
              onClick={() => MySwal.close()}
            >
              GO BACK
            </button>
            <button
              className="btn btn-outline-primary overlay-btn small-text"
              onClick={() => {
                MySwal.close();
                sessionStorage.removeItem("hasUnsavedTeamScores");
                sessionStorage.removeItem("hasUnsavedCarePlan");
                sessionStorage.removeItem("hasUnsavedFunctionalReview");
                logoutFunction();
              }}
            >
              YES, LOGOUT
            </button>
          </div>
        </div>
      ),
      focusConfirm: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      heightAuto: false, // Prevent SweetAlert from modifying body height
      customClass: {
        container: 'logout-warning-container',
        popup: 'logout-warning-popup'
      },
      didOpen: () => {
        // Add class to body to ensure footer stays visible
        document.body.classList.add('logout-modal-active');
      },
      willClose: () => {
        // Remove class from body when modal closes
        document.body.classList.remove('logout-modal-active');
      }
    });
  } else {
    // No unsaved changes, proceed with logout
    logoutFunction();
  }
};

